// Types Imports
import {
  SET_VZ_ICON_CLICKED,
  SET_CURSOR_ICON_DROPPED,
  SET_ADD_VZ_SETTINGS,
  SET_VZ_NAME,
  SET_VZ_CREATION_MENU,
  SET_INIT_CURSOR_POSITION,
} from '../actions/types';
import { AddVZephyr } from '../utils/interface';

interface AddVZephyrAction {
  type: string;
  payload: any;
}

// State
const initState: AddVZephyr = {
  addVZIconClicked: false,
  cursorIconDropped: false,
  settings: null,
  virtualZephyrName: '',
  vzCreationMenuOpened: false,
  initCursorPosition: { x: 0, y: 0 },
};

// Reducer
export default function (state = initState, action: AddVZephyrAction) {
  const { type, payload } = action;

  switch (type) {
    case SET_VZ_ICON_CLICKED:
      return {
        ...state,
        addVZIconClicked: payload,
      };

    case SET_CURSOR_ICON_DROPPED:
      return {
        ...state,
        cursorIconDropped: payload,
      };

    case SET_ADD_VZ_SETTINGS:
      return {
        ...state,
        settings: payload,
      };

    case SET_VZ_NAME:
      return {
        ...state,
        virtualZephyrName: payload,
      };

    case SET_VZ_CREATION_MENU:
      return {
        ...state,
        vzCreationMenuOpened: payload,
      };

    case SET_INIT_CURSOR_POSITION:
      return {
        ...state,
        initCursorPosition: payload,
      };

    default:
      return state;
  }
}
